

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"role":"img","height":"39","viewBox":"0 0 50 39","width":"50","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n  ", h('title', {}, ["Welcome to Crown Clothing"]), "\n  ", h('text', {"class":[styles && styles["visually-hidden"] || "visually-hidden"].join(' '),"font-size":"0"}, ["Shop at Crown Clothing."]), "\n  ", h('g', {"fill":"none","fill-rule":"evenodd","transform":""}, ["\n    ", h('path', {"d":"m3 14 22 12.5 22-12.5-6.144824 25h-31.77095815z","fill":"#808282"}, []), "\n    ", h('path', {"d":"m25 8 15 31h-30z","fill":"#101a1a","fill-opacity":".262839"}, []), "\n    ", h('g', {"fill":"#5e6363"}, ["\n      ", h('circle', {"cx":"2","cy":"9","r":"2"}, []), "\n      ", h('circle', {"cx":"25","cy":"2","r":"2"}, []), "\n      ", h('circle', {"cx":"48","cy":"9","r":"2"}, []), "\n    "]), "\n  "]), "\n"]);
};

        